<template>
	<v-container grid-list-md>
		<v-layout row wrap>
			<v-flex xs12 md8>
				<v-layout row wrap>
					<v-flex xs12>
						<ValidationProvider
							name="name"
							rules="required"
							v-slot="{ errors, valid }"
						>
							<v-text-field
								v-model="item.code"
								:label="$t('Code')"
								filled
								:error-messages="errors"
								:append-icon="valid ? 'mdi-check' : null"
							>
							</v-text-field>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12>
						<ValidationProvider
							name="name"
							v-slot="{ errors, valid }"
						>
							<form-localized-input
								v-model="item.name"
								:errors="errors"
								:valid="valid"
							>
							</form-localized-input>
						</ValidationProvider>
					</v-flex>

					<v-flex xs12>
						<ValidationProvider
							name="description"
							v-slot="{ errors, valid }"
						>
							<form-localized-editor
								v-model="item.description"
								:errors="errors"
								:valid="valid"
							>
							</form-localized-editor>
						</ValidationProvider>
					</v-flex>

					<v-flex xs12 md4>
						<v-switch
							v-model="item.settings.delivery_module"
							:label="$t('Delivery Module')"
						></v-switch>
					</v-flex>
					<v-flex xs12 md4>
						<v-switch
							v-model="item.settings.pickup_module"
							:label="$t('Pickup Module')"
						></v-switch>
					</v-flex>
					<v-flex xs12 md4>
						<v-switch
							v-model="item.settings.dine_in_module"
							:label="$t('Dinein Module')"
						></v-switch>
					</v-flex>

					<v-flex xs12 md4>
						<v-switch
							v-model="item.settings.membership_module"
							:label="$t('label.membership_module')"
						></v-switch>
					</v-flex>
					<v-flex xs12 md4>
						<v-switch
							v-model="item.settings.wallet_module"
							:label="$t('label.wallet_module')"
						></v-switch>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12 md4>
				<v-card>
					<v-card-title primary-title>
						<h3>{{ $t("label.image") }}</h3>
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<app-media-library
							v-model="item.image"
						></app-media-library>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
export default {
	props: ["value"],
	computed: {
		item: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit("input", value);
			},
		},
	},
};
</script>